export const ComputeQcFieldName = 'computeQcFieldComponent';
